<div class="process" [ngClass]="{'new puff-in-center': process.isNew}" *ngIf="process">
    <div *ngIf="process.trigger == null">
        <div class="process_header">
            <div class="title">{{ 'FUNNEL.dealPage.projectUpdatedTo' | translate }} <span>{{process.stepName}}</span></div>
            <div class="date">{{process.update_at | date:'d/M/yy HH:mm'}}</div>
        </div>
        <p>{{'FUNNEL.dealPage.processTexts.projectUpdatedTo' | translate: {phase: process.stepName} }}</p>
    </div>
    <div *ngIf="process.trigger != null">
        <ng-container *ngIf="process.trigger.type === 'doc'">
            <div class="process_header">
                <div class="title">{{ 'FUNNEL.dealPage.attachedDocument' | translate }}</div>
                <div class="date">{{process.update_at | date:'d/M/yy HH:mm'}}</div>
            </div>
            <p>{{'FUNNEL.dealPage.processTexts.docAttached' | translate: {doc: process.trigger.info_name} }}</p>
        </ng-container>
    </div>
</div>
